import React from 'react';

const ButtonSpinner = () => (
  <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin flex-shrink-0" />
);

export default ButtonSpinner;